<template>
    <div
        class="nutrient-content-tip"
        v-html="formattedWeakValidTip"
    >
    </div>
</template>

<script>
export default {
    name: 'NutrientContentTip',
    props: {
        htmlContent: {
            type: String,
            default: '',
        },
    },
    computed: {
        formattedWeakValidTip() {
            if (!this.htmlContent) return '';
            const lines = this.htmlContent.split('<br>').filter((line) => line.trim());
            return lines.map((line) => {
                const color = line.includes('不一致') ? 'red' : '#00b85c';
                return `<div style="color: ${color}">${line}</div>`;
            }).join('');
        },
    },
};
</script>

<style lang="scss" scoped>
.nutrient-content-tip {
    line-height: 1.5;
}
</style>
